import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import {
  BackendHealthIndicator,
  BackendHealthStatusProvider,
} from '../../components/BackendHealthStatusContext';

const backendHealthRootWrapper = AppRootWrapperBlueprint.make({
  name: 'backend-health-indicator',
  params: {
    component: ({ children }) => (
      <BackendHealthStatusProvider>
        {children}
        <BackendHealthIndicator />
      </BackendHealthStatusProvider>
    ),
  },
});

export const healthIndicatorModule = createFrontendModule({
  pluginId: 'app',
  extensions: [backendHealthRootWrapper],
});

export { BackendHealthIndicator };
